<template>
  <div class="w-full bg-semantic-surface-container-high px-4 py-8 md:py-16">
    <div
      class="w-full max-w-wrapper-md mx-auto flex justify-center items-center gap-6 md:gap-10"
    >
      <V2IconsLowestPrice
        :primary-color="semanticColorLookup('primary.default')"
        :surface-color="semanticColorLookup('secondary.default')"
        class="min-w-fit"
      />

      <div
        class="exact-w-1 md:h-[6.125rem] h-[10.5rem] bg-semantic-primary-variant-light"
      />

      <div
        class="flex flex-col align-top items-center gap-1 text-semantic-inverse-surface"
      >
        <p
          class="w-full text-xl/[120%] md:text-3xl/[120%] font-semibold"
        >
          {{ title }}
        </p>

        <p v-if="$slots.description" class="md:text-lg/[150%]">
          <slot name="description"> {{ description }} </slot>
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: 'V2MoleculesHomeDirectPrice'
})

defineProps({
  title: {
    type: String,
    default: ''
  },

  description: {
    type: String,
    default: ''
  }
})
</script>
